import { defineComponent as _defineComponent } from 'vue'
import { useDocumentVisibility, useStorage, useWindowFocus } from "@vueuse/core";
import { ref, watch } from "vue";
import { getAppVersion, getBuildDate, getBuildNumber, getCommitHash } from "@/lib/appInfo";
import { PrimaryButton } from "@/components/buttons";
import logger from "@/lib/logger";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

const showDialog = ref(false);

// check every time we switch to this tab
const visibility = useDocumentVisibility();
watch(visibility, (current, previous) => {
  if (current === "visible" && previous === "hidden") {
    if (shouldUpdateApp()) {
      showDialog.value = true;
    } else {
      logger.debug("App is current");
    }
  }
});

// check for application switches too
const focused = useWindowFocus();
watch(focused, (current, previous) => {
  if (current && !previous) {
    if (shouldUpdateApp()) {
      showDialog.value = true;
    } else {
      logger.debug("App is current");
    }
  }
});

// keep running version in localstorage
const runningAppInfo = useStorage(
  "appInfo",
  {
    appVersion: "",
    commitHash: "",
    buildDate: "",
    buildNumber: "",
  });

/**
 * Check if the app should reload.
 * 
 * @returns true if a new version of the app has been deployed
 */
const shouldUpdateApp = () => {
  const { buildNumber } = runningAppInfo.value;
  if (buildNumber === "") {
    runningAppInfo.value.appVersion = getAppVersion();
    runningAppInfo.value.buildDate = getBuildDate();
    runningAppInfo.value.commitHash = getCommitHash();
    runningAppInfo.value.buildNumber = getBuildNumber();
    return false;
  }
  const isCurrent = buildNumber === getBuildNumber();
  return !isCurrent;
};

/**
 * Reloads the page and updates localstorage with new appInfo
 */
const updateApp = () => {
  runningAppInfo.value.appVersion = getAppVersion();
  runningAppInfo.value.buildDate = getBuildDate();
  runningAppInfo.value.commitHash = getCommitHash();
  runningAppInfo.value.buildNumber = getBuildNumber();
  location.reload();
};


const __returned__ = { showDialog, visibility, focused, runningAppInfo, shouldUpdateApp, updateApp, get getAppVersion() { return getAppVersion }, get getBuildNumber() { return getBuildNumber }, get PrimaryButton() { return PrimaryButton } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})